<div class="select" [class]="sizeClass()">
  <!-- Trigger -->
  <button
    type="button"
    class="select__trigger"
    [attr.id]="id()"
    [disabled]="isDisabled()"
    [style.opacity]="triggerOpacity()"
    [class.select__trigger--placeholder]="isPlaceholder()"
    [attr.title]="!isPlaceholder() ? selectedDisplayLabel() : null"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-haspopup]="'listbox'"
    (click)="toggle()"
  >
    <!-- Text content (placeholder/selected + optional floating label) -->
    <span class="select__text" [class.select__text--floating]="showFloatingLabel()">
      @if (showFloatingLabel()) {
        <span class="select__floating-label">{{ floatingLabel() }}</span>
      }

      <span class="select__value">
        @if (isPlaceholder()) {
          {{ placeholder() }}
        } @else {
          {{ selectedDisplayLabel() }}
        }
      </span>
    </span>

    @if (showSelectedCountBadge() && selectedCount() > 1) {
      <span class="select__badge" aria-label="Selected options count">
        {{ selectedCount() }}
      </span>
    }

    <!-- Chevron icon -->
    @if (showChevron()) {
      <span class="select__icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="currentColor">
          <path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z"></path>
        </svg>
      </span>
    }
  </button>

  <!-- Panel (rendered in CDK Overlay) -->
  <ng-template #panelTpl>
    <div
      #panelEl
      class="select__panel"
      role="listbox"
      [attr.aria-labelledby]="id()"
      [attr.aria-multiselectable]="multiple() ? 'true' : null"
      [style.max-height]="panelMaxHeightStyle()"
    >
      @if (searchable()) {
        <div class="select__search">
          <input
            #searchEl
            type="text"
            class="select__search-input"
            placeholder="Search…"
            autocomplete="off"
            (input)="onSearchInput($event)"
            (click)="$event.stopPropagation()"
          />
        </div>
      }

      @for (opt of filteredOptions(); track opt.value) {
        <button
          type="button"
          class="select__option"
          [class.select__option--selected]="isOptionSelected(opt.value)"
          [class.select__option--multiple]="multiple()"
          [attr.aria-selected]="isOptionSelected(opt.value)"
          [attr.data-selected]="isOptionSelected(opt.value) ? 'true' : null"
          [disabled]="opt.disabled ?? false"
          (click)="select(opt)"
        >
          @if (multiple()) {
            <span class="select__checkbox" aria-hidden="true">
              @if (isOptionSelected(opt.value)) {
                <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 -960 960 960" width="18" fill="currentColor">
                  <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"></path>
                </svg>
              }
            </span>
          }

          <span class="select__option-label">{{ opt.label }}</span>
        </button>
      } @empty {
        <div class="select__empty">No results</div>
      }
    </div>
  </ng-template>
</div>
